<!--
作者：name
时间：2020年03月10日 16:33
功能：
-->
<template>
  <div class="sbgl">
    <img :src="list[index]" class="img" @click="onClick" />
    <div class="option">
      <img :src="jt" class="jt" @click="add('syy')" />
      <div class="info" v-if="show">{{index+1}}/{{list.length}}</div>
      <img :src="jt" class="jt right" @click="add('xyy')" />
    </div>
  </div>
</template>

<script>
import jt from '@/assets/jt.png'
import sbglimg1 from '@/assets/sbgl/sbgl1.jpg'
import sbglimg2 from '@/assets/sbgl/sbgl2.jpg'
import sbglimg3 from '@/assets/sbgl/sbgl3.jpg'
import sbglimg4 from '@/assets/sbgl/sbgl4.jpg'
import sbglimg5 from '@/assets/sbgl/sbgl5.jpg'
import sbglimg6 from '@/assets/sbgl/sbgl6.jpg'
import sbglimg7 from '@/assets/sbgl/sbgl7.jpg'

export default {
  data () {
    return {
      jt,
      list: [
        sbglimg1,sbglimg2,sbglimg3,sbglimg4,sbglimg5,sbglimg6,sbglimg7
      ],
      index: 0,
      show: true
    }
  },
  methods: {
    onClick() {
      let me = this;
      if (me.index < me.list.length - 1) {
        me.index ++;
      }
      me.show = false;
      me.$nextTick(_ => {
        me.show = true;
      });
    },
    add(type) {
      let me = this;
      if (type == 'syy' && me.index !=0) {
        me.index --;
      } else if (type == 'xyy' && me.index < me.list.length - 1) {
        me.index ++;
      }
      me.show = false;
      me.$nextTick(_ => {
        me.show = true;
      });
    }
  }
}
</script>

<style scoped>
.sbgl {
  width: 100%;
  height: 100vh;
  text-align: center;
  background-color: #282c34;
}

.option {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}

.img {
  margin-top: 20px;
  height: 90%;
}

.jt {
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.jt:active {
  opacity: 0.8;
}

.right {
  transform: rotate(180deg);
}

.info {
  color: #fff;
  margin: 0 10px;
}
</style>